/**
 * Redux reducer for the luci panel.
 * @module redux/reducers/luciPanel
 */
import { ASSET_SELECTED } from '../actions/asset';
import { REQUEST_PANEL, REQUEST_PANEL_FAILED, RECEIVED_PANEL } from '../actions/luciPanel';

const initialState = {};

const ACTION_HANDLERS = {
  [ASSET_SELECTED]: () => (initialState),
  [REQUEST_PANEL]: (state) => ({
    ...state
  }),
  [REQUEST_PANEL_FAILED]: (state) => ({
    ...state
  }),
  [RECEIVED_PANEL]: (state, action) => ({
    ...state,
    panel: action.payload.panel
  })
};

export default function luciPanel(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/luciPanel.js